import { Expose } from 'class-transformer';

export enum DispositionProcessContactType {
    QA_DOC_PACKAGE_PROVIDER = 'QA_DOC_PACKAGE_PROVIDER',
    RECEIVING_DOCS_PROVIDER = 'RECEIVING_DOCS_PROVIDER',
    TEMP_DATA_LOGGER = 'TEMP_DATA_LOGGER',
}

export class DispositionProcessContactDto {
    /**
     * Contact ID reference
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    contactId: string;

    /**
     * Type of contact role
     * @example 'QA_DOC_PACKAGE_PROVIDER'
     */
    @Expose()
    contactType: DispositionProcessContactType;

    /**
     * Contact full name (populated from related contact)
     * @example 'John Smith'
     */
    @Expose()
    fullName?: string;

    /**
     * Contact email address
     * @example 'john.smith@example.com'
     */
    @Expose()
    email?: string;

    /**
     * Contact phone number
     * @example '+1-555-123-4567'
     */
    @Expose()
    phone?: string;

    /**
     * Contact position/title
     * @example 'Quality Manager'
     */
    @Expose()
    positionTitle?: string;
} 